import type { AutomationsTranslation } from './types';

export const automationsHi: AutomationsTranslation = {
  nav: 'ऑटोमेशन',
  title: 'ऑटोमेशन',
  description:
    'अपने-आप काम करने वाले नियम: आपकी वेबसाइट पर संदेश, और चैट में जवाब, टैग और टिकट। नियम तभी चलता है जब वह प्रकाशित हो और चालू हो।',
  loading: 'ऑटोमेशन लोड हो रहे हैं',
  brand: 'ब्रांड',
  open: 'ऑटोमेशन',
  openLabel: '{{name}} के ऑटोमेशन',
  guide: 'ऑटोमेशन कैसे काम करते हैं',
  noPermission: 'आपकी भूमिका ऑटोमेशन नहीं बदल सकती। वर्कस्पेस के मालिक या एडमिनिस्ट्रेटर से कहें।',
  forbidden: {
    title: 'आप ऑटोमेशन नहीं देख सकते',
    description: 'वर्कस्पेस के मालिक या एडमिनिस्ट्रेटर से ऐसी भूमिका माँगें जो ऑटोमेशन देख सके।',
  },
  noBrands: {
    title: 'अभी कोई ब्रांड नहीं',
    description: 'पहले एक ब्रांड और उसकी वेबसाइट जोड़ें। फिर उसके ऑटोमेशन यहाँ सेट करें।',
    action: 'ब्रांड और इंस्टॉल पर जाएँ',
  },
  new: 'नया ऑटोमेशन',
  sections: {
    visitor: {
      title: 'आपकी वेबसाइट पर',
      description: 'चैट बटन के पास संदेश जो विज़िटर को पूछने के लिए बुलाते हैं। ये विज़िटर के ब्राउज़र में चलते हैं।',
    },
    conversation: {
      title: 'चैट में',
      description: 'चैट चलते समय जवाब, नोट, टैग, प्राथमिकता, टीम और टिकट।',
    },
    empty: 'अभी कुछ नहीं।',
  },
  status: {
    off: 'बंद',
    draft: 'सिर्फ़ ड्राफ़्ट',
    changes: 'संस्करण {{version}} प्रकाशित · अप्रकाशित बदलाव',
    published: 'संस्करण {{version}} प्रकाशित',
  },
  list: {
    edit: 'बदलें',
    editLabel: '{{name}} बदलें',
    duplicate: 'कॉपी बनाएँ',
    duplicateLabel: '{{name}} की कॉपी बनाएँ',
    delete: 'हटाएँ',
    deleteLabel: '{{name}} हटाएँ',
    switchLabel: '{{name}} चलाएँ',
    inBrowser: 'विज़िटर के ब्राउज़र में चलता है',
    neverRan: 'अभी तक नहीं चला',
    ranOnce: 'इस हफ़्ते एक बार चला',
    ranTimes: 'इस हफ़्ते {{n}} बार चला',
    ranLast: '{{ran}} · आख़िरी बार {{when}}',
    copyName: '{{name}} (कॉपी)',
    duplicated: '{{name}} ड्राफ़्ट के रूप में बना।',
    turnedOn: '{{name}} चालू है।',
    turnedOff: '{{name}} बंद है।',
    deleted: '{{name}} हटाया गया।',
    deleteTitle: '{{name}} हटाएँ?',
    deleteBody:
      'इसके संस्करण और इसने जो किया उसका रिकॉर्ड भी हट जाएगा। इसे वापस नहीं किया जा सकता। अभी के लिए रोकना हो तो इसे बंद करें।',
    deleteConfirm: 'ऑटोमेशन हटाएँ',
  },
  gallery: {
    title: 'टेम्पलेट से शुरू करें',
    description: 'शुरुआत के लिए एक नियम चुनें। यह ड्राफ़्ट के रूप में सेव होता है, ताकि चलने से पहले आप इसे जाँच सकें।',
    ready: 'तैयार नियम',
    scratch: 'शुरू से बनाएँ',
    scratchDescription: 'एक ख़ाली नियम जिसे आप ख़ुद लिखें।',
    website: 'आपकी वेबसाइट पर',
    chat: 'चैट में',
    use: 'इस्तेमाल करें',
    useLabel: 'टेम्पलेट {{name}} इस्तेमाल करें',
    created: '{{name}} ड्राफ़्ट के रूप में बना।',
    chooseTag: 'टैग आप चुनते हैं।',
  },
  templates: {
    welcome: {
      name: 'स्वागत जवाब',
      description: 'जब चैट शुरू हो और किसी व्यक्ति का इंतज़ार हो, बताएँ कि जल्द ही कोई जवाब देगा।',
    },
    rescue: {
      name: 'चैट बचाव',
      description: '90 सेकंड तक जवाब न मिलने पर माफ़ी माँगें, ईमेल पता पूछें और प्राथमिकता बढ़ाएँ।',
    },
    returning: {
      name: 'लौटकर आए विज़िटर के लिए संदेश',
      description: 'तीसरी या उसके बाद की विज़िट पर, 5 सेकंड बाद मदद ऑफ़र करें।',
    },
    pricing: {
      name: 'प्राइसिंग पेज पर मदद',
      description: 'प्राइसिंग पेज पर 30 सेकंड के बाद, सवालों के जवाब देने की पेशकश करें।',
    },
    outOfHours: {
      name: 'काम के घंटों के बाहर जवाब',
      description: 'काम के घंटों के बाहर, बताएँ कि आप कब जवाब देंगे और चैट को टिकट बनाएँ।',
    },
    tagByPage: {
      name: 'पेज के हिसाब से टैग',
      description: 'चेकआउट पेज पर शुरू होने वाली चैट पर टैग लगाएँ।',
    },
    scratchWebsite: {
      name: 'नया वेबसाइट संदेश',
      description: 'आपकी वेबसाइट पर एक संदेश।',
    },
    scratchChat: {
      name: 'नया चैट ऑटोमेशन',
      description: 'चैट में काम करने वाला नियम।',
    },
  },
  limits: {
    title: 'संदेशों की सीमा',
    description: 'आपके पास वेबसाइट के कितने भी ऑटोमेशन हों, एक विज़िटर को ज़्यादा से ज़्यादा इतने संदेश दिखते हैं।',
    maxPerDay: 'एक विज़िटर को एक दिन में दिखने वाले संदेश',
    maxPerDayHint: '1 से 3 तक।',
    dismissHours: 'विज़िटर के एक संदेश बंद करने के बाद, इंतज़ार करें (घंटे)',
    dismissHoursHint: '1 से 168 (एक हफ़्ता) तक।',
    invalid: '{{min}} से {{max}} तक कोई पूर्ण संख्या लिखें।',
    save: 'सीमा सेव करें',
    saved: '{{name}} के लिए संदेशों की सीमा सेव हुई।',
  },
  editor: {
    loading: 'ऑटोमेशन लोड हो रहा है',
    back: 'सभी ऑटोमेशन',
    kinds: { visitor: 'वेबसाइट ऑटोमेशन', conversation: 'चैट ऑटोमेशन' },
    name: 'नाम',
    nameHint: 'आपकी टीम के लिए। ग्राहक इसे कभी नहीं देखते।',
    whenStep: {
      title: 'जब',
      description: 'नियम किससे शुरू होता है।',
      event: 'घटना',
      seconds: {
        page_view: 'पेज पर सेकंड',
        customer_waiting: 'जवाब के बिना सेकंड',
      },
      secondsHint: '{{min}} से {{max}} तक।',
      kindNote:
        'वेबसाइट ऑटोमेशन वेबसाइट पर ही रहता है, और चैट ऑटोमेशन चैट में। दूसरी तरह का बनाने के लिए नया ऑटोमेशन शुरू करें।',
    },
    ifStep: {
      title: 'अगर',
      description: 'क्या सही होना चाहिए। हर बार चलाने के लिए इसे ख़ाली छोड़ दें।',
      match: 'तब चलाएँ जब',
      all: 'सभी सही हों',
      any: 'कोई भी सही हो',
      condition: 'शर्त {{number}}',
      field: 'जानकारी',
      op: 'जाँच',
      value: 'मान',
      yes: 'हाँ',
      no: 'नहीं',
      empty: 'कोई शर्त नहीं: घटना होने पर नियम हर बार चलता है।',
      count: '{{max}} में से {{n}}',
      add: 'शर्त जोड़ें',
      added: 'शर्त {{number}} जोड़ी गई।',
      remove: 'शर्त {{number}} हटाएँ',
      removeShort: 'हटाएँ',
      removed: 'शर्त {{number}} हटाई गई।',
      full: 'एक नियम में ज़्यादा से ज़्यादा {{max}} शर्तें होती हैं।',
      addValue: 'जोड़ें',
      addValueLabel: 'शर्त {{number}} में जोड़ें',
      removeValue: '{{value}} हटाएँ',
      countryHint: 'दो अक्षरों के देश कोड, जैसे PK या AE। हर एक के बाद Enter दबाएँ।',
      languageHint: 'भाषा कोड, जैसे ar या en। हर एक के बाद Enter दबाएँ।',
      tagHint: 'ब्रांड के टैग लोड नहीं हो सके। टैग लिखें और Enter दबाएँ।',
      noTags: 'इस ब्रांड के अभी कोई टैग नहीं हैं। उन्हें सेव किए गए जवाब और टैग में जोड़ें।',
      noTeams: 'इस ब्रांड की अभी कोई सपोर्ट टीम नहीं है।',
    },
    thenStep: {
      title: 'तो',
      description: 'नियम क्या करता है, इसी क्रम में।',
      action: 'कार्य {{number}}',
      type: 'यह करें',
      count: '{{max}} में से {{n}}',
      add: 'कार्य जोड़ें',
      added: 'कार्य {{number}} जोड़ा गया।',
      remove: 'कार्य {{number}} हटाएँ',
      removeShort: 'हटाएँ',
      removed: 'कार्य {{number}} हटाया गया।',
      full: 'एक नियम में ज़्यादा से ज़्यादा {{max}} कार्य होते हैं।',
      prompt: 'वेबसाइट संदेश',
      message: 'संदेश',
      messageHint: 'अंग्रेज़ी ज़रूरी है। ख़ाली छोड़ी गई भाषा में अंग्रेज़ी दिखती है। ज़्यादा से ज़्यादा {{max}} अक्षर।',
      note: 'टीम के लिए नोट',
      tag: 'टैग',
      tagPlaceholder: 'टैग चुनें',
      tagUnknown: '“{{tag}}” इस ब्रांड के टैग में नहीं है। प्रकाशित करने से पहले कोई टैग चुनें।',
      tagFree: 'टैग का नाम',
      tagFreeHint: 'ब्रांड के टैग लोड नहीं हो सके। टैग बिल्कुल सही लिखें।',
      team: 'टीम',
      teamPlaceholder: 'टीम चुनें',
      priority: 'प्राथमिकता',
    },
    fields: {
      page_url: 'पेज का पता',
      referrer: 'कहाँ से आए (रेफ़रर)',
      visit_count: 'अब तक की विज़िट',
      country: 'देश',
      device: 'डिवाइस',
      language: 'भाषा',
      signed_in: 'ग्राहक साइन इन है',
      hours_open: 'काम के घंटों में',
      anyone_online: 'टीम में कोई ऑनलाइन है',
      owner: 'चैट किसके पास है',
      tag: 'टैग',
      team: 'टीम',
    },
    ops: {
      contains: 'में शामिल है',
      starts_with: 'से शुरू होता है',
      is: 'है',
      not_contains: 'में शामिल नहीं है',
      at_least: 'कम से कम',
      at_most: 'ज़्यादा से ज़्यादा',
      is_not: 'नहीं है',
    },
    events: {
      page_view: 'विज़िटर किसी पेज पर है',
      chat_started: 'चैट शुरू होती है',
      customer_waiting: 'ग्राहक जवाब का इंतज़ार कर रहा है',
      chat_closed: 'चैट बंद होती है',
      offline_message: 'जब कोई जवाब न दे सके तब संदेश छोड़ा जाता है',
    },
    actions: {
      show_prompt: 'वेबसाइट संदेश दिखाएँ',
      send_message: 'संदेश भेजें',
      add_note: 'निजी नोट जोड़ें',
      add_tag: 'टैग जोड़ें',
      set_priority: 'प्राथमिकता तय करें',
      assign_team: 'टीम को भेजें',
      make_ticket: 'टिकट बनाएँ',
    },
    warnings: {
      title: 'यह नियम सेव हो सकता है, पर ऐसे ही प्रकाशित नहीं हो सकता:',
      field_not_allowed: 'इस तरह के ऑटोमेशन में यह जानकारी नहीं मिलती। कोई और चुनें।',
      action_not_allowed: 'इस तरह के ऑटोमेशन में यह कार्य उपलब्ध नहीं है।',
      action_repeated: 'यह कार्य नियम में पहले से है। नियम इसे सिर्फ़ एक बार करता है।',
      prompt_required: 'वेबसाइट ऑटोमेशन एक संदेश दिखाता है। “वेबसाइट संदेश दिखाएँ” कार्य जोड़ें।',
      message_needs_people:
        'इस चैट में AI जवाब दे रहा है। इस नियम का संदेश उसे बीच में रोक देगा — ‘चैट किसके पास है AI नहीं है’ जोड़ें।',
      message_after_close: 'चैट बंद होने के बाद संदेश नहीं भेजा जा सकता।',
    },
    problems: {
      name: 'ऑटोमेशन को नाम दें।',
      seconds: '{{min}} से {{max}} तक सेकंड की पूर्ण संख्या लिखें।',
      conditionValue: 'शर्त {{number}}: कोई मान चुनें या लिखें।',
      conditionNumber: 'शर्त {{number}}: {{min}} से {{max}} तक कोई पूर्ण संख्या लिखें।',
      conditionLong: 'शर्त {{number}}: ज़्यादा से ज़्यादा {{max}} अक्षर इस्तेमाल करें।',
      messageEnglish: 'कार्य {{number}}: शब्द अंग्रेज़ी में लिखें।',
      messageLong: 'कार्य {{number}}: हर भाषा में ज़्यादा से ज़्यादा {{max}} अक्षर इस्तेमाल करें।',
      note: 'कार्य {{number}}: नोट लिखें।',
      tag: 'कार्य {{number}}: टैग चुनें।',
      team: 'कार्य {{number}}: टीम चुनें।',
      noActions: 'कम से कम एक कार्य जोड़ें।',
    },
    save: 'ड्राफ़्ट सेव करें',
    publish: 'प्रकाशित करें',
    saved: '{{name}} का ड्राफ़्ट सेव हुआ।',
    published: '{{name}} संस्करण {{version}} के रूप में प्रकाशित हुआ।',
    unsaved: 'आपके कुछ बदलाव सेव नहीं हुए हैं।',
    reset: 'बदलाव वापस लें',
    enabled: 'चालू',
    enabledHint: 'बंद करने पर नियम रहता है पर कभी नहीं चलता।',
    turnedOn: '{{name}} चालू है।',
    turnedOff: '{{name}} बंद है।',
    statusLine: {
      published: 'संस्करण {{version}}, {{who}} ने प्रकाशित किया, {{when}}।',
      publishedBySystem: 'संस्करण {{version}}, {{when}} प्रकाशित हुआ जब आपके संदेश यहाँ लाए गए।',
      draft: 'अभी प्रकाशित नहीं हुआ, इसलिए नहीं चलता।',
      changes: 'ड्राफ़्ट में ऐसे बदलाव हैं जो अभी प्रकाशित नहीं हुए।',
      off: 'बंद है, इसलिए नहीं चलता।',
    },
    conflict:
      'आपके खोलने के बाद किसी और ने यह ऑटोमेशन बदला। उनका संस्करण देखने के लिए फिर से लोड करें; यहाँ के आपके बदलाव खो जाएँगे।',
    reload: 'फिर से लोड करें',
    reloaded: 'नया संस्करण लोड हुआ।',
    versions: {
      title: 'संस्करण',
      description:
        'हर प्रकाशन रखा जाता है। वापस लाने पर संस्करण ड्राफ़्ट में कॉपी होता है; उसे फिर चलाने के लिए प्रकाशित करें।',
      empty: 'अभी प्रकाशित नहीं हुआ।',
      version: 'संस्करण {{version}}',
      by: '{{who}} ने प्रकाशित किया, {{when}}',
      bySystem: 'Hamnivo ने {{when}} प्रकाशित किया',
      current: 'अभी चल रहा है',
      restore: 'वापस लाएँ',
      restoreLabel: 'संस्करण {{version}} वापस लाएँ',
      restoreTitle: 'संस्करण {{version}} वापस लाएँ?',
      restoreBody:
        'ड्राफ़्ट की जगह संस्करण {{version}} आ जाएगा। जो चल रहा है, वह प्रकाशित करने पर ही बदलेगा।',
      restoreConfirm: 'ड्राफ़्ट में वापस लाएँ',
      restored: 'संस्करण {{version}} ड्राफ़्ट में कॉपी हुआ।',
      saveFirst: 'पहले अपने बदलाव सेव करें या वापस लें।',
    },
    runs: {
      title: 'हाल में चले',
      description: 'इस नियम ने चैट में क्या किया, सबसे नया पहले।',
      empty: 'यह अभी तक नहीं चला।',
      when: 'कब',
      chat: 'चैट',
      actions: 'कार्य',
      result: 'नतीजा',
      open: 'चैट खोलें',
      noChat: 'कोई चैट नहीं',
      version: 'संस्करण {{version}}',
      outcomes: { done: 'हो गया', skipped: 'छोड़ा गया', failed: 'विफल' },
      reasons: {
        ai_has_chat: 'संदेश नहीं भेजा गया: चैट AI के पास थी।',
        message_limit: 'संदेश नहीं भेजा गया: अपने-आप भेजे जाने वाले संदेशों की रोज़ की सीमा पूरी हो गई।',
        no_bot: 'संदेश नहीं भेजा गया: चैट में भेजने के लिए कोई बॉट नहीं है।',
        window_closed:
          'संदेश नहीं भेजा गया: ग्राहक के आख़िरी संदेश के 24 घंटे बाद WhatsApp सिर्फ़ टेम्पलेट संदेशों की अनुमति देता है।',
      },
      noActions: 'कुछ नहीं',
    },
    try: {
      title: 'आज़माएँ',
      description:
        'किसी विज़िटर या चैट का ब्योरा दें और देखें कि यह नियम क्या करेगा। यह वही जाँच है जो असली नियम करता है।',
      sample: 'नमूना',
      unknown: 'पता नहीं',
      yes: 'हाँ',
      no: 'नहीं',
      tagsHint: 'टैग को कॉमा से अलग करें।',
      countryHint: 'दो अक्षरों का कोड, जैसे PK।',
      would: 'यह नियम चलेगा।',
      wouldNot: 'यह नियम नहीं चलेगा।',
      verdicts: {
        true: 'सही',
        false: 'सही नहीं',
        null: 'पता नहीं, इसलिए सही नहीं',
      },
      noConditions: 'कोई शर्त नहीं: घटना होने पर यह हर बार चलता है।',
      preview: 'ग्राहक को क्या दिखता है',
      previewIn: '{{language}} में, विज़िटर की भाषा।',
      noWords: 'यह नियम ग्राहक से कुछ नहीं कहता।',
    },
  },
  devices: { desktop: 'कंप्यूटर', mobile: 'फ़ोन', tablet: 'टैबलेट' },
  owners: {
    ai: 'AI',
    waiting: 'अभी कोई नहीं (व्यक्ति का इंतज़ार)',
    person: 'कोई व्यक्ति',
  },
  priorities: { urgent: 'अति आवश्यक', high: 'ऊँची', medium: 'मध्यम', low: 'कम' },
  summary: {
    sentence: '{{event}}, अगर {{conditions}} → {{actions}}',
    always: '{{event}}, तो {{actions}}',
    aTeam: 'किसी टीम',
    owners: { ai: 'AI', waiting: 'अभी कोई नहीं', person: 'कोई व्यक्ति' },
    devices: { desktop: 'कंप्यूटर', mobile: 'फ़ोन', tablet: 'टैबलेट' },
    priorities: { urgent: 'अति आवश्यक', high: 'ऊँची', medium: 'मध्यम', low: 'कम' },
    events: {
      page_open: 'जब कोई विज़िटर पेज खोले',
      page_view: 'जब कोई विज़िटर {{duration}} से किसी पेज पर हो',
      chat_started: 'जब चैट शुरू हो',
      customer_waiting: 'जब ग्राहक {{duration}} से जवाब का इंतज़ार कर रहा हो',
      chat_closed: 'जब चैट बंद हो',
      offline_message: 'जब कोई जवाब न दे सके और संदेश छोड़ा जाए',
    },
    fields: {
      page_url: 'पेज का पता',
      referrer: 'रेफ़रर',
      visit_count: 'विज़िट की संख्या',
      country: 'देश',
      device: 'डिवाइस',
      language: 'भाषा',
      signed_in: 'साइन इन',
      hours_open: 'काम के घंटे',
      anyone_online: 'कोई ऑनलाइन',
      owner: 'चैट जिसके पास है वह',
      tag: 'टैग',
      team: 'टीम',
    },
    ops: {
      contains: '{{field}} में {{value}} शामिल है',
      starts_with: '{{field}} {{value}} से शुरू होता है',
      is: '{{field}} {{value}} है',
      not_contains: '{{field}} में {{value}} शामिल नहीं है',
      at_least: '{{field}} कम से कम {{value}} है',
      at_most: '{{field}} ज़्यादा से ज़्यादा {{value}} है',
      is_not: '{{field}} {{value}} नहीं है',
    },
    flags: {
      hours_open: { yes: 'काम के घंटे चल रहे हैं', no: 'काम के घंटों के बाहर का समय है' },
      anyone_online: { yes: 'टीम में कोई ऑनलाइन है', no: 'टीम में कोई ऑनलाइन नहीं है' },
      signed_in: { yes: 'ग्राहक साइन इन है', no: 'ग्राहक साइन इन नहीं है' },
    },
    actions: {
      show_prompt: 'संदेश दिखाएँ',
      send_message: 'संदेश भेजें',
      add_note: 'निजी नोट जोड़ें',
      add_tag: 'टैग {{tag}} जोड़ें',
      set_priority: 'प्राथमिकता {{priority}} करें',
      assign_team: '{{team}} को भेजें',
      make_ticket: 'टिकट बनाएँ',
    },
  },
};
